import { fmtDate } from "../api";
import { useLang, useT } from "../i18n";
import { Head, useApi } from "../ui";

interface Badge { key: string; name: string; description: string; target: number; value: number; earnedAt?: string }

/** Badges (docs/37 §6): the eight automatic badges and their progress. */
export function Badges() {
  const t = useT();
  const lang = useLang();
  const { data } = useApi<{ badges: Badge[] }>("/badges");
  return (
    <>
      <Head eyebrow={t("badges.eyebrow")} title={t("nav.badges")} />
      <div className="badges" data-testid="badges">{(data?.badges ?? []).map((b) => { const p = Math.min(100, Math.round((b.value / b.target) * 100)); return (
        <div key={b.key} className={`badge-c${b.earnedAt ? " got" : ""}`} data-badge={b.key}><span className="medal">{b.earnedAt ? "✓" : `${p}%`}</span><b>{b.name}</b><small>{b.description}</small>{b.earnedAt ? <small>Earned {fmtDate(b.earnedAt, lang)}</small> : <div className="bar"><i style={{ width: `${p}%` }} /></div>}</div>
      ); })}</div>
    </>
  );
}
